export function getSelectTagLabel(item) {
  return item.label
}
